import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.events__splide' ).length ) {
        $( '.events__splide' ).each( function( _index, element ) {
          const slider = new Splide( element, {
            type: 'slide',
            gap: '2rem',
            perPage: 3,
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              768: {
                perPage: 1,
                gap: '1rem',
              },
              1024: {
                perPage: 2,
              },
            },
          } );

          slider.on( 'overflow', function( isOverflow ) {
            slider.options = {
              arrows: isOverflow,
              drag: isOverflow,
            };
          } );

          slider.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'events', COMPONENT );
} )( app );
